import { Box, Link, Stack, Typography } from "@mui/material";
import React from "react";
import { thumbnailService } from "../../../Core/Api/services";
import { ThumbnailSize } from "../../../Core/Api/Thumbnail/thumbnail-api-service";
import { GetTitleRouterPath } from "../../../Utils/helpers";
import { Link as RouterLink } from "react-router";
import { Img } from "react-image";

export type TableCellMovieProps = {
  id: number;
  name: string;
  noImg?: boolean;
  customerId?: string;
  idDisplayed?: "id" | "customerId";
  isDrive?: boolean;
};

const TableCellMovie: React.FC<TableCellMovieProps> = (props) => {
  const { id, name, noImg, customerId, idDisplayed = "id", isDrive = false } = props;

  return (
    <Stack
      spacing={1.5}
      direction="row"
      alignItems="flex-start"
      mt={1}
      mb={1}
      sx={{
        wordBreak: "break-word",
        wordWrap: "break-word",
      }}
    >
      {!noImg ? (
        <Img
          src={thumbnailService.GetObjectPosterUrl(id, ThumbnailSize.small)}
          alt={`poster ${id}`}
          loading="lazy"
          style={{ objectFit: "contain" }}
          container={(children) => {
            // <img> will be rendered as child of
            return (
              <Box
                height="100%"
                sx={{ width: 30, height: 40, flexShrink: 0, borderRadius: "2px", clipPath: "content-box" }}
              >
                {children}
              </Box>
            );
          }}
        />
      ) : (
        <Box sx={(theme) => ({ width: 30, height: 40, flexShrink: 0, background: theme.palette.background.default })} />
      )}
      <Stack title={name}>
        {id !== null ? (
          <Link
            underline="hover"
            variant="body1"
            color="text.primary"
            fontWeight={500}
            target="_blank"
            component={RouterLink}
            onClick={(e) => e.stopPropagation()}
            to={`${GetTitleRouterPath(isDrive)}/${id}`}
          >
            {name}
          </Link>
        ) : (
          <Typography>{name}</Typography>
        )}
        {id !== null && (
          <Typography variant="body2" color="text.secondary">
            #{idDisplayed === "customerId" && customerId ? customerId : id}
          </Typography>
        )}
      </Stack>
    </Stack>
  );
};

export default TableCellMovie;
